import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";

export interface ICodeCar {
  title: string
  code: number
  titleDDMS: string
}

export interface ICarColor {
  categoryCarId: number
  categoryCarTitle: string
  code: string
  colorId: number
  colorTitle: string
  groupColorId: number
  groupColorTitle: string
  id: number
  title: string
  titleDDMS: string
}
export interface ICarColorEdit {
  id: number,
  title: string
  categoryCarId: number
  groupColorId: number
  codeCar: ICodeCar[]
}
export interface ICarColorGroup {
  id: number,
  title: string
}

export interface IColorFilter {
  categoryCarId?: number;
  groupColorId?: number;
  search?: string;
}
//danh sách màu xe
export const getListCarColor = async (
  limit?: number, pageNumber?: number, search?: string, categoryCarId?: number, groupColorId?: number) => {
  const path = "car/listCarColor"
  const params = {
    limit, pageNumber, search, categoryCarId, groupColorId
  }
  const result: ResponseSuccessTotal<ICarColor[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


// Thêm màu xe
export const addColorCar = async (
  // title: string, categoryCarId: number, codeCar: ICodeCar, groupColorId: number
  categoryCarId: number, codeCar: ICodeCar, groupColorId: number
) => {
  const url = `car/addColorCar`
  const params = {
    categoryCarId, codeCar, groupColorId
  }
  const result: ResponseSuccess<ICarColor> = await axiosClient.post(
    url, params
  )
  return result
}
// thông tin màu xe
export const gInforColorCar = async (id: number) => {
  const url = `car/infoCarColor`
  const params = {
    id
  }
  const result: ResponseSuccessTotal<ICarColorEdit> = await axiosClient.get(
    url, { params }
  )
  return result
}
//Chỉnh sửa màu xe
export const editColorCar = async (
  // id: number, title: string, categoryCarId: number, codeCar: ICodeCar[], groupColorId: number
  id: number, categoryCarId: number, codeCar: ICodeCar[], groupColorId: number

) => {
  const url = `car/editCarColor`;
  const params = {
    id, categoryCarId, codeCar, groupColorId
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

//Xóa màu xe
export const deleteCarColor = async (
  id: Number
) => {
  const url = `car/deleteCarColor`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}

//danh sách nhóm màu xe
export const getListCarColorGroup = async (
  limit?: number, pageNumber?: number, search?: string) => {
  const path = "car/listGroupColor"
  const params = {
    limit, pageNumber, search
  }
  const result: ResponseSuccessTotal<ICarColorGroup[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

// Thêm nhóm màu xe
export const addColorCarGroup = async (
  title: string
) => {
  const url = `car/addGroupColor`
  const params = {
    title
  }
  const result: ResponseSuccess<ICarColorGroup> = await axiosClient.post(
    url, params
  )
  return result
}
// thông tin nhóm màu xe
export const gInforColorCarGroup = async (id: number) => {
  const url = `car/infoGroupColor`
  const params = {
    id
  }
  const result: ResponseSuccessTotal<ICarColorGroup> = await axiosClient.get(
    url, { params }
  )
  return result
}
//Chỉnh sửa nhóm màu xe
export const editColorCarGroup = async (
  id: number, title: string
) => {
  const url = `car/editGroupColor`;
  const params = {
    id, title
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

//Xóa nhóm màu xe
export const deleteCarColorGroup = async (
  id: Number
) => {
  const url = `car/deleteGroupColor`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}
